<template>
  <b-row>
    <b-col cols="12" md="10" offset-md="1">
      <b-card class="shadow px-1 py-2 mb-5">

        <onboarding-stepper
          v-if="currentStep.stepper"
          :currentStep="currentStep"
          :steps="steps"
        />

        <b-row class="pt-5 pb-4 px-sm-5">
          <b-col lg="4">
            <b-jumbotron variant="info">
              <p><b>Introduction</b></p>
              <p>Let us know a little bit about you and the potential avenues you’d like to explore.</p>
            </b-jumbotron>
          </b-col>
          <b-col lg="8">
            <b-row>
              <b-col cols="10">
                <p><b>I'd like to find out about internal job opportunities</b><br/>
                <span class="text-muted">Let us know if you’d like to be forwarded jobs from your current employer.</span></p>
              </b-col>
              <b-col cols="2" class="d-flex align-items-start justify-content-end">
                <b-form-checkbox size="lg" :checked="isJobAlert" @change="$emit('toggleIsJobAlert')"></b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col cols="10">
                <p><b>I'd like to find out about internal projects</b><br/>
                <span class="text-muted">Let us know if you’d like to be forwarded projects from your current employer.</span></p>
              </b-col>
              <b-col cols="2" class="d-flex align-items-start justify-content-end">
                <b-form-checkbox size="lg" :checked="true"></b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col cols="10">
                <p><b>I'd like to hear about being mentored</b><br/>
                <span class="text-muted">Let us know if you’d like to be mentored by other senior members at your current work place.</span></p>
              </b-col>
              <b-col cols="2" class="d-flex align-items-start justify-content-end">
                <b-form-checkbox size="lg" :checked="true"></b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col cols="10">
                <p><b>I'd like to explore being a mentor</b><br/>
                <span class="text-muted">Let us know if you’d like to potentially mentor someone at your current employer.</span></p>
              </b-col>
              <b-col cols="2" class="d-flex align-items-start justify-content-end">
                <b-form-checkbox size="lg"></b-form-checkbox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="d-flex justify-content-between align-items-center px-md-5">
            <a class="text-secondary" href="#" @click.prevent="() => $emit('goBack')">Go back</a>
            <b-button @click.prevent="() => $emit('goNext')" class="px-3" variant="primary">Continue</b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapRoot } from '@src/mixins/root';
import OnboardingStepper from '@/components/profile/OnboardingStepper';

const templateMap = {
  ONBOARDING_WELCOME_TITLE: 'title',
  ONBOARDING_WELCOME_DESCRIPTION: 'description',
};

export default {
  name: 'OnboardingIntroVideo',
  components: {
    OnboardingStepper,
  },
  props: {
    currentStep: {
      type: Object,
      default: () => null,
    },
    steps: {
      type: Array,
      default: () => [],
    },
    isJobAlert: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapRoot([ 'company' ]),
    templates() {
      const templates = {};
      if (this.company && Array.isArray(this.company.templatedStrings)) {
        const { templatedStrings } = this.company;
        Object.keys(templateMap).forEach(templateKey => {
          const template = templatedStrings.find(el => el.key === templateKey);
          templates[templateMap[templateKey]] = template ? template.value : null;
        });
      }
      console.log(templates);
      return templates;
    }
  },
};
</script>

<style lang="scss" scoped>
.onboarding-video {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/onboarding/Introduction.vue